// CameraComponent.js
import React, { useEffect, useRef, useState } from "react";

const CameraComponent = ({ hide, image }) => {
    const videoRef = useRef(null);
    const canvasRef = useRef(null); // A reference to the hidden canvas
    const [stream, setStream] = useState(null);
    const [error, setError] = useState(null);
    const [capturedImage, setCapturedImage] = useState(null);

    // Function to start the camera
    const startCamera = async () => {
        try {
            const mediaStream = await navigator.mediaDevices.getUserMedia({
                video: { facingMode: "environment" } // Request the back camera on mobile devices
            });
            if (videoRef.current) {
                videoRef.current.srcObject = mediaStream;
            }
            setStream(mediaStream);
        } catch (err) {
            console.error("Error accessing camera:", err);
            setError("Unable to access camera. Please check your permissions.");
        }
    };

    const captureImage = () => {
        if (!videoRef.current || !canvasRef.current) return;

        // Set the canvas dimensions to the video's dimensions
        const video = videoRef.current;
        const canvas = canvasRef.current;
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;

        // Draw the current video frame on the canvas
        const ctx = canvas.getContext("2d");
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

        // Convert the canvas image to a data URL (PNG format)
        const imageDataURL = canvas.toDataURL("image/png");
        setCapturedImage(imageDataURL);

    };

    const sendHandleImage = () => {
        image(capturedImage)
        hide()
    }

    // Function to stop the camera
    const stopCamera = () => {
        if (stream) {
            stream.getTracks().forEach((track) => track.stop());
            setStream(null);
        }
    };

    // Start the camera when the component mounts and stop when it unmounts.
    useEffect(() => {
        startCamera();

        return () => {
            stopCamera();
        };
    }, []);

    return (
        <div>
            {error && <p style={{ color: "red" }}>{error}</p>}
            {/* Video element for the live camera feed */}
            <video
                ref={videoRef}
                autoPlay
                playsInline
                style={{ width: "100%", maxHeight: "400px" }}
            />
            <div className="mt-2">
                {/* Button to capture an image */}
                <button onClick={captureImage} className="btn btn-primary me-2">
                    Capture Image
                </button>
                {/* Button to stop the camera */}
                <button onClick={stopCamera} className="btn btn-danger">
                    Stop Camera
                </button>
            </div>
            {/* Hidden canvas used for capturing the image */}
            <canvas ref={canvasRef} style={{ display: "none" }} />
            {/* Display the captured image */}
            {capturedImage && (
                <>
                    <div className="mt-2">
                        <h5>Captured Image:</h5>
                        <img src={capturedImage} alt="captured" style={{ width: "100%" }} />
                    </div>

                    <button onClick={sendHandleImage} className="btn btn-primary mt-2">
                        Upload
                    </button>
                </>
            )}
        </div>
    );
};

export default CameraComponent;
